























import { Component, Prop, Vue } from 'vue-property-decorator';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import { isMobile } from '@/main';

@Component({
  components: {
    navdraw: NavigationDrawer
  }
})
export default class Header extends Vue {
  drawer: boolean = false;

  isMobile() {
    return isMobile();
  }

  logout() {
    this.$store.commit('logoutUser');
    this.$router.push('/login');
  }

  toggleDrawer() {
    this.drawer = !this.drawer;
    setTimeout(() => {
      this.updateDrawerState(this.drawer);
    }, 300);
  }

  get loggedIn() {
    return this.$store.getters.isAuthenticated;
  }

  updateDrawerState(state: boolean) {
    this.$store.commit('updateDrawerState', state);
    this.drawer = state;
  }
}
